import { createApp } from 'vue'
import App from './App.vue'

const mountID = '#jhs-slideshow-app'
const mountEl = document.querySelector(mountID)

if (mountEl) {
	createApp(App, { ...mountEl.dataset }).mount(mountID)
}